/****************************************************************
 * Test
 */
const TEST_CONFIG = { test: false, stepNumber: 5, useFakeData: false };

const test = () => {
  //Hide all elements
  const elToHide = [
    ...new Set(state.currentStepElements.map((x) => x.elementsToShow).flat()),
  ];
  elToHide.forEach((x) => hide(x));

  state.step = TEST_CONFIG.stepNumber - 1;
  changeStep();
};

/****************************************************************
 * Common
 */

let firstVisit;
let firstVisitLS = localStorage.getItem('firstVisit');
if (!firstVisitLS) {
  firstVisit = { rvl: true, ptc: true };
} else {
  firstVisit = JSON.parse(firstVisitLS);
}

const getEl = (elName) => document.querySelector(elName);

//Init

const urlApi = window.urlApi;

let isMobile = false;

// Home
const buttonGo = getEl('#bouton_go');
const home = getEl('#home');

//General
const helpMessage = getEl('#helpmsg');
const info = getEl('#infos');
const divsvg = getEl('#divsvg');
const svg = getEl('#svg');

//Steps
const backArrow = getEl('#backArrow');
const etapes = getEl('#etapes');
const etape = getEl('#etape');
const instruction = getEl('#instruction');
const validationButton = getEl('#bouton_valider');

//Immat
const immatContainer = getEl('#container-immat');
const immatInput = getEl('#immat');
const methodSelectVehicle = getEl('#method-select-vehicle');
const searchByImmat = getEl('#search-by-immat');
const searchByDetails = getEl('#search-by-details');
const dialogErrorImmat = getEl('#error-immat');
const dialogClose = getEl('#error-immat .close');
const buttonErrorRedirect = getEl('#error-redirect');

//Gauge
const gauge = getEl('#valeurJauge2');
const fuel = getEl('#Carburant');
const cursor = getEl('#Curseur');
const basJauge = 478;
const hautJauge = -2.5;
const maxy = 472;
const miny = hautJauge;
let offset, lastHauteurJauge, lastCoord;
let dragging = false;
let only_click = false;

//Select
const inputSelectDropDown = getEl('#selected_option');
const selector = getEl('.select_wrap');
// const selectListOption = getEl('.select_ul');
const filterBoite = getEl('#filter-boite');
const radioBoite = document.querySelectorAll('input[name=filter-boite]');
const filterFuel = getEl('#filter-fuel');
const radioFuel = document.querySelectorAll('input[name=filter-fuel]');
const filterPower = getEl('#filter-power');
const card = getEl('.card');
const inputKeyword = getEl('#input_keyword');
const selectCardVersion = getEl('.select_card_version');
const containerScrollable = getEl('.container-scrollable');
const containerFilter = getEl('.container-filter');
const noResult = getEl('#noresult');
// Map
const destinationStep = getEl('#destination_step');
const distanceForm = getEl('#distance_form');
const origin = getEl('#origin');
const destination = getEl('#destination');
const Autho = getEl('#Autho');
const distanceTrajet = getEl('#distance_trajet');
// const in_mile = getEl('#in_mile');
const in_kilo = getEl('#in_kilo');
const duration_text = getEl('#duration_text');
const duration_value = getEl('#duration_value');
const from = getEl('#from');
const to = getEl('#to');

//Result
const result = getEl('#result');
const resultMap = getEl('#resultMap');
const resultLitrage = getEl('#result h3');
const resultMessage = getEl('#result h4');
const buttonCloseResult = getEl('#cross');
const feedback = getEl('#feedbackH5');
const vehiculeBrand = getEl('#marque-vehicule');
const vehiculeModel = getEl('#modele-vehicule');
const vehiculeReservoir = getEl('#volume-reservoir-vehicule');
const vehiculeCircu = getEl('#annee-circu-vehicule');
const vehiculeConsoUrb = getEl('#conso-urbaine-vehicule');
const vehiculeConsoExtraUrb = getEl('#conso-extra-urbaine-vehicule');
const vehiculeConsoMixte = getEl('#conso-mixte-vehicule');
const chevauxVehicule = getEl('#nb-chevaux-vehicule');
let buttonDialogResult;
let dialogResultVehicule;
let dialogResultVehiculeClose;

const stepVehiculeDetailRVL = [
  {
    name: 'Etape n°3.1',
    instruction: '3/3 Sélectionnez le véhicule',
    selectInstruction: 'Sélectionnez la marque',
    dataSource: `${urlApi}/brands/captcha/TOKEN`,
    elementsToShow: [etapes, validationButton, backArrow, selector],
    stepName: 'selectionMarque',
  },
  {
    name: 'Etape n°3.2',
    instruction: '3/3 Sélectionnez le véhicule',
    selectInstruction: 'Sélectionnez le modèle',
    dataSource: `${urlApi}/versions/captcha/TOKEN/model`,
    elementsToShow: [etapes, validationButton, backArrow, selector],
    stepName: 'selectionModele',
  },
  {
    name: 'Etape n°3.3',
    instruction: '3/3 Sélectionnez le véhicule',
    selectInstruction: 'Sélectionnez la version',
    dataSource: `${urlApi}/versions/captcha/TOKEN/generiq`,
    elementsToShow: [
      etapes,
      validationButton,
      backArrow,
      containerFilter,
      filterFuel,
      filterBoite,
      filterPower,
      selectCardVersion,
    ],
    stepName: 'selectionVersion',
  },
  {
    name: 'Result',
    elementsToShow: [result, backArrow],
    stepName: 'resultRVL',
  },
];

const stepImmatRVL = [
  {
    name: 'Etape n°3',
    instruction: '3/3 Sélectionnez le véhicule',
    dataSource: `${urlApi}/versions/captcha/TOKEN/immat`,
    elementsToShow: [
      etapes,
      validationButton,
      immatContainer,
      backArrow,
      immatInput,
    ],
    stepName: 'immat',
  },
  {
    name: 'Result',
    elementsToShow: [result, backArrow],
    stepName: 'resultRVL',
  },
];

const stepVehiculeDetailPTC = [
  {
    name: 'Etape n°2.1',
    instruction: '2/3 Sélectionnez le véhicule',
    selectInstruction: 'Sélectionnez la marque',
    dataSource: `${urlApi}/brands/captcha/TOKEN`,
    elementsToShow: [etapes, validationButton, backArrow, selector],
    stepName: 'selectionMarque',
  },
  {
    name: 'Etape n°2.2',
    instruction: '2/3 Sélectionnez le véhicule',
    selectInstruction: 'Sélectionnez le modèle',
    dataSource: `${urlApi}/versions/captcha/TOKEN/model`,
    elementsToShow: [etapes, validationButton, backArrow, selector],
    stepName: 'selectionModele',
  },
  {
    name: 'Etape n°2.3',
    instruction: '2/3 Sélectionnez le véhicule',
    selectInstruction: 'Sélectionnez la version',
    dataSource: `${urlApi}/versions/captcha/TOKEN/generiq`,
    elementsToShow: [
      etapes,
      validationButton,
      backArrow,
      containerFilter,
      filterFuel,
      filterBoite,
      filterPower,
      selectCardVersion,
    ],
    stepName: 'selectionVersion',
  },
  {
    name: 'Etape n°3',
    instruction: '3/3 Où souhaitez-vous aller ?',
    elementsToShow: [etapes, validationButton, backArrow, destinationStep],
    stepName: 'map',
  },
  {
    name: 'Result',
    elementsToShow: [result, backArrow],
    stepName: 'resultPTC',
  },
];
const stepImmatPTC = [
  {
    name: 'Etape n°2',
    instruction: '2/3 Sélectionnez le véhicule',
    dataSource: `${urlApi}/versions/captcha/TOKEN/immat`,
    elementsToShow: [
      etapes,
      validationButton,
      immatContainer,
      backArrow,
      immatInput,
    ],
    stepName: 'immat',
  },
  {
    name: 'Etape n°3',
    instruction: '3/3 Où souhaitez-vous aller ?',
    elementsToShow: [etapes, validationButton, backArrow, destinationStep],
    stepName: 'map',
  },
  {
    name: 'Result',
    elementsToShow: [result, backArrow],
    stepName: 'resultPTC',
  },
];

const state = {
  rvlProcess: window.location.href.includes('RVL'),
  step: 0,
  stepName: 'home',
  captchaVerif: '',
  niveauCarbAct: -1,
  niveauCarbSouhaite: -1,
  selectedBrand: null,
  selectedModel: null,
  selectedPower: null,
  selectedBoite: null,
  selectedFuel: null,
  selectedVersion: null,
  searchVersion: null,
  selectedImmat: null,
  currentData: [],
  currentListVersion: [],
  stepElementsRVL: [
    {
      name: 'Home',
      instruction: '',
      elementsToShow: [info, home],
      stepName: 'home',
    },
    {
      name: 'Etape n°1',
      instruction: '1/3 Indiquez le niveau de carburant actuel',
      elementsToShow: [
        etapes,
        validationButton,
        helpMessage,
        backArrow,
        divsvg,
      ],
      stepName: 'carburantActuel',
    },
    {
      name: 'Etape n°2',
      instruction: '2/3 Indiquez le niveau de carburant souhaité',
      elementsToShow: [
        etapes,
        validationButton,
        helpMessage,
        backArrow,
        divsvg,
      ],
      stepName: 'carburantSouhaite',
    },
    {
      name: 'Etape n°3',
      instruction: 'Indiquez la méthode de recherche',
      elementsToShow: [etapes, methodSelectVehicle, backArrow, immatInput],
      stepName: 'methodeSelectVehicle',
    },
    {
      name: 'Etape n°3',
      instruction: "3/3 Indiquez votre plaque d'immatriculation",
      dataSource: `${urlApi}/versions/captcha/TOKEN/immat`,
      elementsToShow: [
        etapes,
        validationButton,
        immatContainer,
        backArrow,
        immatInput,
      ],
      stepName: 'immat',
    },
    {
      name: 'Result',
      elementsToShow: [result, backArrow],
      stepName: 'resultRVL',
    },
  ],
  stepElementsPTC: [
    {
      name: 'Home',
      instruction: '',
      elementsToShow: [info, home],
      stepName: 'home',
    },
    {
      name: 'Etape n°1',
      instruction: '1/3 Indiquez le niveau de carburant actuel',
      elementsToShow: [
        etapes,
        validationButton,
        helpMessage,
        backArrow,
        divsvg,
      ],
      stepName: 'carburantActuel',
    },
    {
      name: 'Etape n°2',
      instruction: 'Indiquez la méthode de recherche',
      elementsToShow: [etapes, methodSelectVehicle, backArrow, immatInput],
      stepName: 'methodeSelectVehicle',
    },
    {
      name: 'Etape n°2',
      instruction: "2/3 Indiquez votre plaque d'immatriculation",
      dataSource: `${urlApi}/versions/captcha/TOKEN/immat`,
      elementsToShow: [
        etapes,
        validationButton,
        immatContainer,
        backArrow,
        immatInput,
      ],
      stepName: 'immat',
    },
    {
      name: 'Etape n°3',
      instruction: '3/3 Où souhaitez-vous aller ?',
      elementsToShow: [etapes, validationButton, backArrow, destinationStep],
      stepName: 'map',
    },
    {
      name: 'Result',
      elementsToShow: [result, backArrow],
      stepName: 'resultPTC',
    },
  ],
  currentStepElements: [],
};

state.currentStepElements = state.rvlProcess
  ? state.stepElementsRVL
  : state.stepElementsPTC;

if (!state.rvlProcess) {
  buttonDialogResult = getEl('#open-dialog-result');
  dialogResultVehicule = getEl('#result-vehicule');
  dialogResultVehiculeClose = getEl('#result-vehicule .close');
}
const hide = (el) => {
  !el.classList.contains('hide') && el.classList.add('hide');
};
const show = (el) => {
  el.classList.contains('hide') && el.classList.remove('hide');
};

const changeStep = (next = { nextStep: true }) => {
  const previousState = state.step;
  if (previousState > -1) {
    const elToHide = state.currentStepElements[previousState].elementsToShow;
    elToHide.forEach((el) => hide(el));
  }

  if (state.stepName === 'methodeSelectVehicle') {
    state.currentStepElements.length = state.rvlProcess ? 4 : 3;
    if (state.selectedImmat) {
      state.currentStepElements.push(
        ...(state.rvlProcess ? stepImmatRVL : stepImmatPTC)
      );
    } else {
      state.currentStepElements.push(
        ...(state.rvlProcess ? stepVehiculeDetailRVL : stepVehiculeDetailPTC)
      );
    }
  }

  state.step = next.nextStep ? state.step + 1 : state.step - 1;
  const { stepName, dataSource } = state.currentStepElements[state.step];
  state.stepName = stepName;
  switch (stepName) {
    case 'home':
      loadStep();
      break;
    case 'methodeSelectVehicle':
      loadStep();
      break;
    case 'immat':
      loadStep();
      break;
    case 'carburantActuel':
      next.nextStep && resetFuel();
      loadStep();
      window.removeEventListener('resize', calHeightGauge);
      window.addEventListener('resize', calHeightGauge);
      break;
    case 'carburantSouhaite':
      next.nextStep && resetFuel();
      loadStep();
      window.removeEventListener('resize', calHeightGauge);
      window.addEventListener('resize', calHeightGauge);
      break;
    case 'selectionMarque':
      inputSelectDropDown.value = '';
      loadStep();
      fetchData(
        `${dataSource.replace('TOKEN', state.captchaVerif)}`,
        addSelectListOptionsMarque
      );
      break;
    case 'selectionModele':
      inputSelectDropDown.value = '';
      loadStep();
      fetchData(
        `${dataSource.replace('TOKEN', state.captchaVerif)}/${
          state.selectedBrand
        }`,
        addSelectListOptionsModel
      );
      break;
    case 'selectionVersion':
      // alert(
      //   'Ecrivez avec le plus de précision pour trouver votre résultat plus rapidement'
      // );
      state.selectedPower = null;
      document
        .querySelectorAll(
          'input[name=filter-boite],input[name=filter-fuel],input[name=filter-power]'
        )
        .forEach((x) => (x.checked = false));
      state.selectedBoite = null;
      state.selectedFuel = null;
      state.selectedVersion = null;
      state.searchVersion = null;
      state.currentListVersion = [];
      input_keyword.value = '';
      loadStep();
      if (TEST_CONFIG.test) {
        state.selectedModel = 'Audi A1';
      }
      fetchData(
        `${dataSource.replace('TOKEN', state.captchaVerif)}/${
          state.selectedModel
        }`,
        buildFilterPage
      );
      window.removeEventListener('resize', calHeightCardFilter);
      window.addEventListener('resize', calHeightCardFilter);
      break;
    case 'map':
      distanceForm.reset();
      loadStep();
      break;
    case 'resultRVL':
      loadStep();
      firstVisit.rvl && show(feedback);
      firstVisit = { ...firstVisit, rvl: false };
      localStorage.setItem('firstVisit', JSON.stringify(firstVisit));
      resultHandler();
      break;

    case 'resultPTC':
      loadStep();
      if (firstVisit.ptc) {
        show(feedback);
        resultMap.classList.add('feedback');
      }
      firstVisit = { ...firstVisit, ptc: false };

      localStorage.setItem('firstVisit', JSON.stringify(firstVisit));
      calculateDistance();
      break;

    default:
      break;
  }
};

/****************************************************************
 * INIT
 */

const getMobileOperatingSystemv2 = () => {
  let userAgent = navigator.userAgent || navigator.vendor || window.opera;
  if (/windows phone/i.test(userAgent)) {
    return 'Windows Phone';
  }
  if (/android/i.test(userAgent)) {
    return 'Android';
  }
  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'iOS';
  }
  return 'unknown';
};

// device detection
if (
  /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
    navigator.userAgent
  ) ||
  /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
    navigator.userAgent.substr(0, 4)
  )
) {
  isMobile = true;
}

/****************************************************************
 * HOME
 */

buttonGo.addEventListener('click', () => {
  TEST_CONFIG.test ? test() : changeStep({ nextStep: true });
});

searchByImmat.addEventListener('click', () => {
  state.selectedImmat = true;
  TEST_CONFIG.test ? test() : changeStep({ nextStep: true });
});

searchByDetails.addEventListener('click', () => {
  state.selectedImmat = false;
  TEST_CONFIG.test ? test() : changeStep({ nextStep: true });
});

/****************************************************************
 * STEPS
 */

backArrow.addEventListener('click', () => {
  grecaptcha.ready(function () {
    console.log('grecaptcha ready');
    grecaptcha
      .execute('6Lf6q6kiAAAAAC0ALCEO0-Vhfg5eSu_gJ_lA2-oq', { action: 'click' })
      .then(function (token) {
        state.captchaVerif = token;
        changeStep({ nextStep: false });
      });
  });
});

validationButton.addEventListener('click', (e) => {
  e.preventDefault();
  grecaptcha.ready(function () {
    grecaptcha
      .execute('6Lf6q6kiAAAAAC0ALCEO0-Vhfg5eSu_gJ_lA2-oq', { action: 'click' })
      .then(function (token) {
        state.captchaVerif = token;
        // Add your logic to submit to your backend server here.
        if (state.stepName == 'immat') {
          const url = `${state.currentStepElements[
            state.step
          ].dataSource.replace('TOKEN', state.captchaVerif)}/${
            state.selectedImmat
          }`;
          fetch(url)
            .then((json) => json.json())
            .then((data) => {
              if (data.statusCode) {
                dialogErrorImmat.showModal();
                return;
              } else {
                state.selectedVersion = { ...data };
                changeStep({ nextStep: true });
              }
            })
            .catch((err) => {
              if (err) {
                dialogErrorImmat.showModal();
              }
            });
          // fetchData(
          //   `${state.currentStepElements[state.step].dataSource.replace(
          //     "TOKEN",
          //     state.captchaVerif
          //   )}/${state.selectedImmat}`,
          //   changeStep({ nextStep: true })
          // );
        } else {
          changeStep({ nextStep: true });
        }
      });
  });
});

dialogClose.addEventListener('click', () => {
  dialogErrorImmat.close();
});

const loadStep = () => {
  const currentState = state.currentStepElements[state.step];
  validationButton.disabled = true;

  // if (currentState.stepName == 'map') {
  //   validationButton.disabled = false;
  // }

  currentState.elementsToShow.forEach((el) => show(el));
  if (etape) {
    etape.innerText = currentState.name;
  }
  instruction.innerText = currentState.instruction;
  inputSelectDropDown.setAttribute(
    'placeholder',
    currentState.selectInstruction
  );

  calHeightGauge();
};

/**
 * SELECT
 */

inputSelectDropDown.addEventListener('click', () => {
  if (!selector.classList.contains('active')) {
    selector.classList.add('active');
  }
});

inputSelectDropDown.addEventListener('input', (e) => {
  const search = e.target.value.split(' ');

  if (state.stepName === 'selectionMarque') {
    const filteredData = state.currentData.filter((x) =>
      searchHandler(x, search, 'marque')
    );
    addSelectListOptionsMarque(filteredData);
  } else if (state.stepName === 'selectionModele') {
    const filteredData = state.currentData.filter((x) =>
      searchHandler(x, search, 'model_generique')
    );
    addSelectListOptionsModel(filteredData);
  }
});

const fetchData = (url, callback) => {
  fetch(url)
    .then((json) => json.json())
    .then((data) => {
      if (data.statusCode) {
        return;
      } else {
        state.currentData = [...data];
        callback(data);
      }
    });
};

const addSelectListOptionsMarque = (options) => {
  addSelectListOptions(options, 'marque');
};

const addSelectListOptionsModel = (options) => {
  options.sort((a, b) => b.display_order - a.display_order);
  addSelectListOptions(options, 'model_generique');
};

const addSelectListOptions = (options, propertyToDisplay) => {
  // selectListOption.innerHTML = ''; // On supprime les choix précédents
  const selectListOption = getEl('.select_ul');
  selectListOption && selector.removeChild(selectListOption);

  const builtListOption = document.createElement('ul');
  builtListOption.setAttribute('class', 'select_ul');
  for (const option of options) {
    const liElement = document.createElement('li');
    if (option.display_order > -1) {
      liElement.setAttribute('class', 'top');
    }
    const divElement = document.createElement('div');
    divElement.setAttribute('class', 'option');
    const pElement = document.createElement('p');
    pElement.textContent = option[propertyToDisplay];

    divElement.appendChild(pElement);
    liElement.appendChild(divElement);
    builtListOption.appendChild(liElement);
  }

  selector.appendChild(builtListOption);
  addClickSelect();
};

const addClickSelect = () => {
  const selectListOptionElement = document.querySelectorAll(
    '.select_wrap .select_ul li'
  );
  [...selectListOptionElement].forEach((el) =>
    el.addEventListener('click', (e) => {
      const selectedEl = e.target.closest('li').querySelector('p').textContent;
      inputSelectDropDown.value = `${selectedEl}`;
      if (state.stepName === 'selectionMarque') {
        state.selectedBrand = selectedEl;
      } else if (state.stepName === 'selectionModele') {
        state.selectedModel = selectedEl;
      }
      if (validationButton.disabled) {
        validationButton.disabled = false;
      }
      if (selector.classList.contains('active')) {
        selector.classList.remove('active');
      }
    })
  );
};

/**
 * Immat
 */

immatInput.addEventListener('input', (e) => {
  const { target, data } = e;

  if (target.value.length === 3 || target.value.length === 7) {
    const immatValue = target.value;
    const immatArray = immatValue.split('');
    // Le user saisi un char
    if (data) {
      if (data !== '-') {
        immatArray.splice(target.value.length - 1, 0, '-');
      }
    } else {
      immatArray.pop();
    }
    immatInput.value = immatArray.join('');
  }
  immatInput.value = immatInput.value.toUpperCase();
  if (target.value.length === 9) {
    validationButton.disabled = false;
    state.selectedImmat = immatInput.value
      .split('')
      .filter((x) => x !== '-')
      .join('');
  }
});

buttonErrorRedirect.addEventListener('click', () => {
  grecaptcha.ready(function () {
    grecaptcha
      .execute('6Lf6q6kiAAAAAC0ALCEO0-Vhfg5eSu_gJ_lA2-oq', { action: 'click' })
      .then(function (token) {
        state.captchaVerif = token;
        dialogErrorImmat.close();
        changeStep({ nextStep: false });
        state.selectedImmat = false;
        changeStep({ nextStep: true });
      });
  });
});

/**
 * Filter
 */

const containerRadioPower = getEl('#filter-power .radios');

const buildFilterPage = (data) => {
  state.currentListVersion = data;

  radioBoite.forEach(
    (el) =>
      (el.onclick = (e) => {
        handlerBoiteFilter(e);
      })
  );
  radioFuel.forEach(
    (el) =>
      (el.onclick = (e) => {
        handlerFuelFilter(e);
      })
  );

  const listPower = [
    ...new Set(
      data
        .filter((x) => x.puissance_fiscale_cv !== 'NC')
        .map((x) => x.puissance_fiscale_cv)
    ),
  ];
  containerRadioPower.innerHTML = '';
  listPower.forEach(
    (x) =>
      (containerRadioPower.innerHTML += `
        <div>
          <input type="radio" id="${x}" name="filter-power" value="${x}">
          <label for="${x}" class="radio-label">${x}cv</label>
        </div>`)
  );

  const radioPower = document.querySelectorAll('input[name=filter-power]');

  radioPower.forEach(
    (el) =>
      (el.onclick = (e) => {
        handlerPowerFilter(e);
      })
  );

  input_keyword.oninput = (e) => {
    _.debounce(handlerSearchFilter(e), 300);
  };

  buildCardList(data);
  addClickCard();
  calHeightCardFilter();
  containerScrollable.scrollTo(0, 0);
};

const handlerBoiteFilter = (e) => {
  if (state.selectedBoite === e.target.value) {
    document
      .querySelectorAll('input[name=filter-boite]')
      .forEach((x) => (x.checked = false));
    state.selectedBoite = '';
  } else {
    state.selectedBoite = e.target.value;
  }
  filterVersion(
    state.currentListVersion,
    state.selectedBoite,
    state.selectedPower,
    state.selectedFuel,
    state.searchVersion
  );
};

const handlerFuelFilter = (e) => {
  if (state.selectedFuel === e.target.value) {
    document
      .querySelectorAll('input[name=filter-fuel]')
      .forEach((x) => (x.checked = false));
    state.selectedFuel = '';
  } else {
    state.selectedFuel = e.target.value;
  }
  filterVersion(
    state.currentListVersion,
    state.selectedBoite,
    state.selectedPower,
    state.selectedFuel,
    state.searchVersion
  );
};

const handlerPowerFilter = (e) => {
  if (state.selectedPower === e.target.value) {
    document
      .querySelectorAll('input[name=filter-power]')
      .forEach((x) => (x.checked = false));
    state.selectedPower = '';
  } else {
    state.selectedPower = e.target.value;
  }

  filterVersion(
    state.currentListVersion,
    state.selectedBoite,
    state.selectedPower,
    state.selectedFuel,
    state.searchVersion
  );
};

const handlerSearchFilter = (e) => {
  if (state.searchVersion != e.target.value) {
    state.searchVersion = e.target.value.split(' ').map((x) => x.toLowerCase());
    filterVersion(
      state.currentListVersion,
      state.selectedBoite,
      state.selectedPower,
      state.selectedFuel,
      state.searchVersion
    );
  }
};

const filterVersion = (data, boite, power, fuel, search) => {
  card.innerHTML = '';
  let filteredData = [...data];
  if (boite) {
    filteredData = filteredData.filter((x) =>
      x.boite_de_vitesse_nb_de_rapports.includes(boite)
    );
  }
  if (power) {
    filteredData = filteredData.filter((x) => x.puissance_fiscale_cv === power);
  }
  if (fuel) {
    filteredData = filteredData.filter((x) => x.motorisation === fuel);
  }
  if (search) {
    filteredData = filteredData.filter((x) => searchHandler(x, search));
  }

  buildCardList(filteredData);
  addClickCard();
};

const buildCardList = (carDataToCardify) => {
  const listUl = getEl('.card');
  listUl && containerScrollable.removeChild(listUl);
  const ulElement = document.createElement('ul');
  ulElement.setAttribute('class', 'card');
  if (carDataToCardify.length > 0) {
    if (!noResult.classList.contains('hide')) {
      noResult.classList.add('hide');
    }
    for (const carData of carDataToCardify) {
      const liElement = document.createElement('li');
      const pElement = document.createElement('p');
      pElement.setAttribute('id', `versionid_${carData.id}`);
      pElement.textContent = carData.version;

      liElement.appendChild(pElement);
      ulElement.appendChild(liElement);
    }
  } else {
    if (noResult.classList.contains('hide')) {
      noResult.classList.remove('hide');
    }
  }

  containerScrollable.appendChild(ulElement);
};

const searchHandler = (dataToFilter, search, property = 'version') => {
  return (
    dataToFilter[property]
      .split(' ')
      .filter(
        (x) =>
          search.filter(
            (searchWord) =>
              x.toLowerCase().indexOf(searchWord.toLowerCase()) > -1
          ).length > 0
      )
      .filter((x) => x).length >= search.length
  );
};

const calHeightCardFilter = () => {
  let nav = getEl('nav');
  let etapesElement = getEl('#etapes');
  let heightToDecrease = [...etapesElement.children, nav]
    .filter(
      (x) =>
        x.getClientRects().length > 0 && x.className !== 'select_card_version'
    )
    .map((x) => x.getClientRects()[0].height + 7);

  let containerHeight = getEl('.ctn').clientHeight;
  let totalHeight = containerHeight - heightToDecrease.reduce((a, b) => a + b);

  getEl('.container-scrollable').style.height = `${totalHeight - 42}px`;
};

const addClickCard = () => {
  const cardElement = document.querySelectorAll('.card li');
  [...cardElement].forEach(
    (el) =>
      (el.onclick = (e) => {
        const versionIdSelected = e.target
          .closest('li')
          .querySelector('p')
          .id.split('versionid_')[1];
        state.selectedVersion = state.currentListVersion.filter(
          (x) => x.id == versionIdSelected
        )[0];
        if (validationButton.disabled) {
          validationButton.disabled = false;
        }

        getEl('.card li.selected') &&
          getEl('.card li.selected').classList.remove('selected');
        e.target.closest('li').classList.add('selected');
      })
  );
};

/****************************************************************
 * MAP
 */

// distanceForm.onsubmit = (e) => {
//   e.preventDefault();
//   calculateDistance();
// };

let observer = new MutationObserver((mutation) => {
  if (!mutation[0].target.classList.contains('hide')) {
    initMap();
  }
});
if (getEl('#destination_step')) {
  observer.observe(getEl('#destination_step'), {
    attributes: true,
    attributeFilter: ['style', 'class'],
  });
}

const calculateDistance = () => {
  const service = new google.maps.DistanceMatrixService();
  service.getDistanceMatrix(
    {
      origins: [origin.value],
      destinations: [destination.value],
      travelMode: google.maps.TravelMode.DRIVING,
      //unitSystem: google.maps.UnitSystem.IMPERIAL, // miles and feet.
      unitSystem: google.maps.UnitSystem.METRIC, // kilometers and meters.
      avoidHighways: false,
      avoidTolls: false,
    },
    callback
  );
};

// get distance results
const callback = (response, status) => {
  if (status != google.maps.DistanceMatrixStatus.OK) {
    result.innerHTML = `Une erreur est survenue: merci de réessayer`;
  } else {
    const capaciteReservoirCurrentVersion =
      state.selectedVersion.volume_du_reservoir_litre;
    const capaciteReservoir =
      capaciteReservoirCurrentVersion !== 'NC'
        ? parseInt(capaciteReservoirCurrentVersion)
        : 50;
    const consoCurrentVersion = state.selectedVersion.consommation_mixte_litre;
    const consomationVoitureParKm =
      consoCurrentVersion !== 'NC'
        ? parseFloat(consoCurrentVersion) / 100
        : 0.065;
    const originAdresse = response.originAddresses[0];
    const destinationAdresse = response.destinationAddresses[0];
    if (response.rows[0].elements[0].status === 'ZERO_RESULTS') {
      result.innerHTML = `Navré mais il n'existe pas d'itinéraire entre ${origin} et ${destination}`;
    } else {
      const distance = response.rows[0].elements[0].distance;
      const duration = response.rows[0].elements[0].duration;
      const distance_in_kilo = distance.value / 1000; // the kilom

      if (distance_in_kilo > 0) {
        const niveauCarburant = state.niveauCarbAct * capaciteReservoir;

        const consoTrajet = distance_in_kilo * consomationVoitureParKm;
        const resultat = niveauCarburant - consoTrajet;
        const mydest = destinationAdresse;
        const fromplace = originAdresse;
        hide(destinationStep);
        show(result);
        resultMap.src = `https://www.google.com/maps/embed/v1/directions?key=${KEY}&origin=${fromplace}+&destination=${mydest}`;
        show(resultMap);
        document.getElementById('imgPouceVert').style.display = 'none';
        document.getElementById('imgPouceOrange').style.display = 'none';
        document.getElementById('imgPouceRouge').style.display = 'none';
        if (resultat > 10) {
          document.getElementById('imgPouceVert').style.display = 'block';
          Autho.innerText = `Vous pourrez vous rendre à votre destination, il vous restera ${Math.round(
            resultat
          )}L dans votre reservoir`;
          distanceTrajet.innerText = `Distance Trajet = ${distance_in_kilo} km `;
        } else if (resultat < 10 && resultat > 0) {
          document.getElementById('imgPouceOrange').style.display = 'block';
          Autho.innerText = `Vous pourrez vous rendre à votre destination, mais il vous restera ${Math.round(
            resultat
          )}L dans votre reservoir`;
          distanceTrajet.innerText = `Distance Trajet = ${distance_in_kilo} km `;
        } else if (resultat < 0) {
          // document.getElementById('img').src = '../images/pouce-rouge.png';
          document.getElementById('imgPouceRouge').style.display = 'block';
          Autho.innerText = `Vous ne pourrez pas vous rendre à votre destination, il vous manquera ${Math.round(
            resultat * -1
          )}L dans votre reservoir`;
          distanceTrajet.innerText = `Distance Trajet = ${distance_in_kilo} km `;
        }
      }

      // const distance_in_mile = distance.value / 1609.34; // the mile
      // const duration_text = duration.text;
      // const duration_value = duration.value;
      // in_mile.innerText = distance_in_mile.toFixed(2);
      // in_kilo.innerText = distance_in_kilo.toFixed(2);
      // duration_text.innerText = duration_text;
      // duration_value.innerText = duration_value;
      // from.innerText = origin;
      // to.innerText = destination;
    }
    resultHandler();
  }
};

/****************************************************************
 * RESULT
 */
if (!state.rvlProcess) {
  buttonDialogResult.addEventListener('click', () => {
    dialogResultVehicule.showModal();
  });

  dialogResultVehiculeClose.addEventListener('click', () => {
    dialogResultVehicule.close();
  });
}

const resultHandler = () => {
  const data = state.selectedVersion.volume_du_reservoir_litre;
  if (data !== 'NC') {
    vehiculeBrand.innerText = state.selectedVersion.marque;
    vehiculeModel.innerText = state.selectedVersion.model_generique;
    vehiculeReservoir.innerText = `${state.selectedVersion.volume_du_reservoir_litre}L`;
    vehiculeCircu.innerText =
      new Date(state.selectedVersion.date1erCir).getFullYear() || 'NC';
    vehiculeConsoUrb.innerText = `${state.selectedVersion.consommation_urbaine_litre}L/100km`;
    vehiculeConsoExtraUrb.innerText = `${state.selectedVersion.consommation_extra_urbaine_litre}L/100km`;
    vehiculeConsoMixte.innerText = `${state.selectedVersion.consommation_mixte_litre}L/100km`;
    chevauxVehicule.innerText = `${state.selectedVersion.puissance_ch}ch`;

    if (state.rvlProcess) {
      const capaciteReservoir = parseInt(data);
      const nbLitres = calculerNbLitres(
        state.niveauCarbAct,
        state.niveauCarbSouhaite,
        capaciteReservoir
      );
      if (nbLitres <= 0) {
        resultLitrage.innerHTML = '';
        resultMessage.innerHTML = `Vous avez dépassé le niveau souhaité de ${Math.abs(
          nbLitres
        )} litres`;
      } else {
        resultLitrage.innerHTML = `${nbLitres} litres`;
        resultMessage.innerHTML = `de carburant à mettre pour atteindre le niveau souhaité`;
      }
    }
  }
};

const calculerNbLitres = (nvActu, nvSouh, capacite) => {
  var nbLitres = (nvSouh - nvActu) * capacite;
  return Math.round(nbLitres);
};
